import {Button, ButtonGroup, List} from '@material-ui/core';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {pushRoute} from 'routes';
import {IInputVoting} from '../../election/store/types';
import {eSingleRequestVotingAsync} from '../store/actions';
import {getESinglePlates} from '../store/selectors';
import {ISinglePlate, ISinglePlateCompetitor} from '../store/types';
import ConfirmSingleVotingDialog from './ConfirmSingleVotingDialog';
import InvalidSingleVotingDialog from './InvalidSingleVotingDialog';
import SingleElectionItem from './SingleElectionItem';

const SingleListElection: React.FC = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const elections: ISinglePlate[] = useSelector(getESinglePlates);
  const [confirmedVote, setConfirmedVote] = useState(false);
  const [showInvalid, setShowInvalid] = useState(false);
  const [clearVotes, setClearVotes] = useState(false);
  const [votes, setVotes] = useState([...elections]);

  const clearChecked = () => {
    setClearVotes(true);

    setTimeout(() => {
      setClearVotes(false);
    }, 1000);
  };

  const changeVote = (plate: ISinglePlate, index: number) => {
    const newVotes = [...votes];
    newVotes[index] = plate;
    setVotes(newVotes);
  };

  const hasInvalidItems = () => {
    const invalids = votes.filter(elect => elect.invalid);
    return !!invalids.length;
  };

  const openConfirmDialog = () => {
    if (hasInvalidItems()) {
      setShowInvalid(true);
    } else {
      setConfirmedVote(true);
    }
  };

  const getdata = () => {
    return votes.map(plate => ({
      plate_uuid: plate.plate.uuid,
      competitors: getCheckedIds(plate.competitors),
    }));
  };

  const getCheckedIds = (listcompetitors: ISinglePlateCompetitor[]) => {
    const checkeds = listcompetitors.filter(comp => comp.checked);
    const checados = checkeds.map(check => check.id);
    return checados;
  };

  const closeConfirmDialog = (action: string) => {
    setConfirmedVote(false);

    switch (action) {
      case 'confirm':
        const data: IInputVoting[] = getdata();

        dispatch(eSingleRequestVotingAsync.request(data));
        dispatch(pushRoute('singleResultVotes'));
        break;
      case 'cancel':
      default:
        // clearChecked();
        break;
    }
  };

  const closeInvalidDialog = () => {
    setShowInvalid(false);
  };

  return (
    <>
      <p className="default-subtitle mt-0 text-center">
        {t('lista-eleicao-simples.faca-sua-escolha')}
      </p>
      <List component="nav" className="list-white" aria-label="eleições">
        {votes.map((value, index) => {
          return (
            <SingleElectionItem
              election={value}
              key={value.plate.id}
              onChange={p => changeVote(p, index)}
              clear={clearVotes}
            />
          );
        })}
      </List>

      <br />
      <br />

      <ButtonGroup className="full-width" color="primary">
        <Button
          className={`button-default btn-color-orange full-width`}
          type="button"
          color="primary"
          variant="contained"
          onClick={clearChecked}
        >
          {t('geral.corrigir')}
        </Button>
        <Button
          className={`button-default btn-green full-width`}
          type="button"
          color="primary"
          variant="contained"
          onClick={openConfirmDialog}
        >
          {t('geral.confirmar')}
        </Button>
      </ButtonGroup>

      <ConfirmSingleVotingDialog
        plates={elections}
        open={confirmedVote}
        onClose={closeConfirmDialog}
      />

      <InvalidSingleVotingDialog
        open={showInvalid}
        onClose={closeInvalidDialog}
      />
    </>
  );
};

export default SingleListElection;



// WEBPACK FOOTER //
// ./src/features/election-single/components/SingleListElection.tsx